import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { IAgentSchema } from '../../types/results';

export interface IAgentProps {
  agentInfo: IAgentSchema;
  isBooked: boolean;
}

export function Agent({ agentInfo, isBooked }: IAgentProps) {
  const { name } = agentInfo;

  return <UIText2 color={isBooked ? 'text-secondary-default' : 'text-primary-default'}>{name}</UIText2>;
}
